import Vue from "vue";
import VueRouter from "vue-router";
import { VIVO_ROUTES } from "./vivo-nav";

Vue.use(VueRouter);

const ifAuthenticated = (to: any, from: any, next: any) => {
  if (localStorage.user) {
    next();
    return;
  }
  next("/");
};

const ifNotAuthenticated = (to: any, from: any, next: any) => {
  if (!localStorage.user) {
    next();
    return;
  }
  next("/home");
};

// C2–C15 screens. Real Phase-2.5 views live in ../views/vivo/*; anything not yet
// built falls back to the ComingSoon placeholder. Routes are derived from the
// single source in ./vivo-nav.js.
const ComingSoon = () => import("../views/ComingSoon.vue");

const SCREENS: Record<string, () => Promise<unknown>> = {
  home: () => import("../views/vivo/home.vue"),
  employees: () => import("../views/vivo/employees.vue"),
  "employees-add": () => import("../views/vivo/employee-add.vue"),
  "employees-import": () => import("../views/vivo/employee-import.vue"),
  "employee-page": () => import("../views/vivo/employee-page.vue"),
  departments: () => import("../views/vivo/departments.vue"),
  // C1/E1: one component serves both the add and the edit route (the route
  // param is what distinguishes them), mirroring the admin portal's formPages().
  "departments-new": () => import("../views/vivo/department-form.vue"),
  "departments-edit": () => import("../views/vivo/department-form.vue"),
  "admin-followup": () => import("../views/vivo/admin-followup.vue"),
  claims: () => import("../views/vivo/claims.vue"),
  "claims-new": () => import("../views/vivo/claim-form.vue"),
  "policy-contract": () => import("../views/vivo/policy-contract.vue"),
  providers: () => import("../views/vivo/providers.vue"),
  reports: () => import("../views/vivo/reports.vue"),
  company: () => import("../views/vivo/company.vue"),
  "chatbot-qa": () => import("../views/vivo/chatbot-qa.vue"),
};

const dashboardChildren = (VIVO_ROUTES as any[]).map((r) => ({
  path: r.path,
  name: r.name,
  component: SCREENS[r.name] || ComingSoon,
  meta: { titleKey: r.titleKey, rtlActive: true },
}));

const routes = [
  {
    // C1 — company login (real shell built in M10)
    path: "/",
    name: "login",
    component: () => import("../views/users/login.vue"),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "",
    component: () => import("../layouts/new/DashboardLayout.vue"),
    beforeEnter: ifAuthenticated,
    children: dashboardChildren,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
